'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = getMetaVerifications;
var lookup = {
  NZ: {
    meta: [{ name: 'google-site-verification', content: 'W3Pn8Nz8-CqGf99aqrIqNiemdd0IfzbC6a0_PeHZ_6I' }, { name: 'msvalidate.01', content: 'D6B4F7BFBF0F89356B1FCC25AC4339F2' }],
    link: [{ rel: 'publisher', href: 'https://plus.google.com/103648286008814473013' }],
    script: [{ type: 'application/ld+json', innerHTML: '{"@context":"http://schema.org","@graph":[{"@type":"WebSite","url":"https://www.seek.co.nz/","name":"SEEK","alternateName":"SEEK NZ","potentialAction":{"@type":"SearchAction","target":"https://www.seek.co.nz/jobs?keywords={search_term_string}","query-input":"required name=search_term_string"}},{"@type":"Organization","url":"https://www.seek.co.nz/","logo":"https://www.seek.co.nz/content/images/logos/seek-logo-positive.svg","contactPoint":[{"@type":"ContactPoint","telephone":"+64-0508-733-569","contactType":"customer service","contactOption":"TollFree"}],"sameAs":["https://www.facebook.com/SEEK/","https://www.instagram.com/seeknz/","https://twitter.com/seekjobsnz","https://plus.google.com/+seeknz"]}]}' }]
  },
  AU: {
    meta: [{ name: 'google-site-verification', content: '8b2SVQ8qa7SzviuSxLuRei-QLhi-bK25lc7ExZVcYlY' }, { name: 'msvalidate.01', content: 'E351C1D9451453DA9E01053A36A1766D' }],
    link: [{ rel: 'publisher', href: 'https://plus.google.com/103674144254402509357' }],
    script: [{ type: 'application/ld+json', innerHTML: '{"@context":"http://schema.org","@graph":[{"@type":"WebSite","url":"https://www.seek.com.au/","name":"SEEK","alternateName":"SEEK AU","potentialAction":{"@type":"SearchAction","target":"https://www.seek.com.au/jobs?keywords={search_term_string}","query-input":"required name=search_term_string"}},{"@type":"Organization","url":"https://www.seek.com.au/","logo":"https://www.seek.com.au/content/images/logos/seek-logo-positive.svg","contactPoint":[{"@type":"ContactPoint","telephone":"+61-1300-658-700","contactType":"customer service","contactOption":"TollFree"}],"sameAs":["https://www.facebook.com/SEEK/","https://www.instagram.com/seekau/","https://twitter.com/seekjobs","https://www.youtube.com/user/SEEKJobs","https://plus.google.com/+seekau"]}]}' }]
  }
};

function getMetaVerifications(locale) {
  return lookup[locale];
}

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-seo/build/get-meta-verifications.js
 ** module id = 555
 ** module chunks = 0
 **/